import React from 'react'
import { Edit as EditIcon } from '@material-ui/icons'
import useEventDrilldownStyles from 'Event/hooks/useEventDrilldownStyles'

export const EventDrilldownSectionHeader = ({ title, onEdit }: { title: string; onEdit?: () => void }) => {
  const classes = useEventDrilldownStyles()

  return (
    <div className={classes.sectionHeader}>
      <div className={classes.sectionTitle}>{title}</div>
      {onEdit && <EditIcon className={classes.editIcon} onClick={onEdit} />}
    </div>
  )
}
